import { useGetCategoryIds } from 'pages/reimbursements/hooks/useGetCategoryIds';

export function useHasCategoryAccess(categoryId, skip = false) {
    const categoryIds = useGetCategoryIds();

    if (categoryIds === undefined || categoryId === undefined || skip) {
        return undefined;
    }

    return categoryIds.includes(categoryId);
}
